<template>
  <div class="d-flex gap-1 mw-350 px-4 pt-4 pb-3">
    <v-menu v-model="menuDateStart" :close-on-content-click="false" offset-overflow offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="labelDateStart"
          v-bind="attrs"
          v-on="on"
          :label="$t('filters.date.startDate')"
          hide-details
          clearable
          outlined
          readonly
          dense
        />
      </template>
      <v-date-picker
        v-model="dateStart"
        @change="handleStartDateSelect"
        :max="dateEnd"
        color="primary"
        no-title
        flat
      />
    </v-menu>
    <v-menu v-model="menuDateEnd" :close-on-content-click="false" offset-overflow offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="labelDateEnd"
          v-bind="attrs"
          v-on="on"
          :label="$t('filters.date.endDate')"
          hide-details
          clearable
          outlined
          readonly
          dense
        />
      </template>
      <v-date-picker
        v-model="dateEnd"
        @change="handleEndDateSelect"
        :min="dateStart"
        color="primary"
        no-title
        flat
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'FilterDateRange',

  props: {
    fetchData: {
      type: Function,
      required: true,
    },

    startDateProp: {
      type: String,
      default: 'startDate',
    },

    endDateProp: {
      type: String,
      default: 'endDate',
    },
  },

  computed: {
    ...mapGetters(['filters']),
  },

  methods: {
    ...mapMutations(['setFilters', 'setCurrentPage']),

    resetDateRange() {
      this.labelDateStart = ''
      this.labelDateEnd = ''
    },

    setFieldLabel() {
      this.labelDateStart = this.dateStart ? moment(this.dateStart).format('DD/MM/YYYY') : ''
      this.labelDateEnd = this.dateEnd ? moment(this.dateEnd).format('DD/MM/YYYY') : ''
    },

    emitDateRange() {
      this.$emit('emitDateRange', { start: this.dateStart, end: this.dateEnd })
    },

    applyFilter() {
      this.setFilters({ ...this.filters, ...this.params })
      this.setCurrentPage(1)
      this.setFieldLabel()
      this.fetchData()
    },

    formatTimezoneDate(date) {
      return moment.tz(date, this.timezone).format('YYYY-MM-DDTHH:mm:ssZ')
    },

    handleStartDateSelect(date) {
      const formattedDate = moment(date).format(`YYYY-MM-DDT00:00:00`)
      const timezoneDate = this.formatTimezoneDate(formattedDate)

      this.params = { ...this.filters, ...{ [this.startDateProp]: timezoneDate }}

      this.emitDateRange()
      this.applyFilter()
    },

    handleEndDateSelect(date) {
      const formattedDate = moment(date).format(`YYYY-MM-DDT23:59:59`)
      const timezoneDate = this.formatTimezoneDate(formattedDate)

      this.params = { ...this.filters, ...{ [this.endDateProp]: timezoneDate }}

      this.emitDateRange()
      this.applyFilter()
    },
  },

  data() {
    return {
      timezone: moment.tz.guess(),

      menuDateStart: false,
      menuDateEnd: false,

      labelDateStart: '',
      labelDateEnd: '',

      dateStart: null,
      dateEnd: null,

      params: {},
    }
  },
}
</script>
